import type {
  GetSessionsAssetsResponse,
  SessionsAsset,
} from '@carboncopyco/data';
import { RightOutlineIcon } from '@carboncopyco/icons';
import { RecordingTypes } from '@carboncopyco/types';
import { Badge, ColorHex, TextBase } from '@carboncopyco/ui';
import { integersFormatter } from '@carboncopyco/utils';
import type { Col } from '../../../../FixedTable';
import { RowPreviewButton } from '../../SharedSections';
import { DemoName } from '../../SharedSections/DemoName';

const getBadgeLabel = (asset: SessionsAsset) => {
  if (asset.assetType === 'playbook') {
    return 'multi assets';
  }
  return asset.recordingType === RecordingTypes.overlay
    ? 'live app'
    : 'cloned app';
};

export const getCols = (
  isInModal?: boolean
): Col<GetSessionsAssetsResponse>[] => [
  {
    alignment: 'left',
    title: 'Demo name',
    width: isInModal ? 280 : 250,
    render: ({ asset }) => <DemoName demo={asset} />,
  },
  {
    alignment: 'left',
    title: 'Base',
    width: 75,
    render: ({ asset }) => (
      <Badge
        size="sm"
        label={getBadgeLabel(asset)}
        variant="primary"
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Sessions',
    width: 100,
    render: (demo) => {
      return (
        <TextBase
          label={integersFormatter(demo.totalPresented)}
          color="text-ds-natural-600"
        />
      );
    },
  },
  {
    alignment: 'right',
    title: 'Shares',
    width: 100,
    render: (demo) => (
      <TextBase
        label={integersFormatter(demo.totalShares)}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Visits',
    width: 100,
    render: (demo) => (
      <TextBase
        label={integersFormatter(demo.totalVisits)}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: '',
    width: 60,
    render: ({ asset }) =>
      asset.assetType === 'demo' && <RowPreviewButton demo={asset} />,
  },
  {
    alignment: 'right',
    title: '',
    width: 50,
    render: ({ asset }) => (
      <RightOutlineIcon
        size={16}
        color={asset.isDeleted ? ColorHex.natural200 : ColorHex.natural600}
      />
    ),
  },
];
